import { Outlet, Navigate } from "react-router-dom";
import isTokenExpired from "../helper/isTokenExpired";

const PrivateRoutes = () => {
  const token = localStorage.getItem("token");
  const tokenExp = isTokenExpired(token)
  const refreshToken = localStorage.getItem("refreshToken");

  // ✅ Case 1: No tokens at all → must log in
  if (!token || !refreshToken) {
    return <Navigate to="/verifyEmail" />;
  }

  // ⚠️ Case 2: Token expired → temporarily allow route
  // Let baseApi handle auto-refresh during the next API call
  if (tokenExp) {
    localStorage.getItem("refreshToken");
     <Outlet />
  }

  return <Outlet />;
};

export default PrivateRoutes;
